// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1P1wA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__nF_vK","obliqueLine":"membershipbadge_obliqueLine__2_UJs"};